import React from "react";
import { FiEdit3 } from "react-icons/fi";

/**
 * Átomo que muestra la cobertura de una necesidad como `current/needed` dentro
 * de una píldora coloreada:
 * - verde: overstaffing (current > needed)
 * - blanco: cobertura exacta (current === needed)
 * - rojo: understaffing (current < needed)
 *
 * Reutiliza las clases `need-value-box` / `bg-green` / `bg-red` de las tablas de
 * necesidades para mantener la misma estética.
 */
const CoverageBox = ({ current = 0, needed = 0, isEdited = false }) => {
	let statusClass = "";
	if (needed > 0) {
		statusClass =
			current > needed ? "bg-green" : current < needed ? "bg-red" : "";
	}

	return (
		<div className={`need-value-box coverage-box ${statusClass}`}>
			<span className="coverage-current">{current}</span>
			<span className="coverage-sep">/</span>
			<span className="coverage-needed">{needed}</span>
			{isEdited ? <FiEdit3 className="need-icon icon-edited" /> : null}
		</div>
	);
};

export default CoverageBox;
